const PRODUCTION_PARTNER_DOMAINS = ["partner.dardoc.com", "partner.dardoc.co"];

export function isProductionPartnerHost(hostname?: string): boolean {
  if (!hostname) return false;

  const normalizedHostname = hostname.toLowerCase().replace(/\.$/, "");
  return PRODUCTION_PARTNER_DOMAINS.some(
    (domain) => normalizedHostname === domain || normalizedHostname.endsWith(`.${domain}`)
  );
}
